export const SmallWidgetsData = [
  {
    title: 'New Orders',
    color: 'primary',
    total: 2_435,
    gros: 50,
    icon: 'new-order',
  },
  {
    title: 'New Customers',
    color: 'warning',
    total: 2_908,
    gros: 20,
    icon: 'customers',
  },
  {
    title: 'Average Sale',
    color: 'secondary',
    total: 389,
    gros: 10,
    prefix: '$',
    icon: 'sale',
    suffix: 'k',
  },
  {
    title: 'Gross Profit',
    color: 'success',
    total: 3_908,
    gros: 80,
    prefix: '$',
    icon: 'profit',
  },
  {
    title: 'Gross Profit',
    color: 'success',
    total: 3_908,
    gros: 80,
    prefix: '$',
    icon: 'profit',
  },
  {
    title: 'Gross Profit',
    color: 'success',
    total: 3_908,
    gros: 80,
    prefix: '$',
    icon: 'profit',
  },
];

// ValuableCustomer Dara //
export const ValuableCustomerData = [
  {
    name: 'Jane Cooper',
    image: '1.jpg',
    email: 'alma.lawson@gmail.com',
  },
  {
    name: ' Cameron Willia',
    image: '2.jpg',
    email: 'tim.jennings@gmail.com',
  },
  {
    name: 'Floyd Miles',
    image: '9.jpg',
    email: 'kenzi.lawson@gmail.com',
  },
  {
    name: 'Dianne Russell',
    image: '5.jpg',
    email: 'curtis.weaver@gmail.com',
  },
  {
    name: 'Guy Hawkins',
    image: '3.jpg',
    email: 'curtis.weaver@gmail.com',
  },
];

export const RecentOrderTable = [
  [
    {
      image: '4.png',
      title: 'T-shirt',
      id: '#CFDE-2163',
      qty: 'X1',
      status: 'Verified',
      statusCode: 'success',
      price: 56,
      total: 100,
      iconName: '24-hour',
    },
    {
      image: '3.png',
      title: 'Pink T-shirt',
      id: '#CFDE-2780',
      qty: 'X2',
      status: 'Rejected',
      statusCode: 'danger',
      price: 156,
      total: 870,
      iconName: '24-hour',
    },
  ],
  [
    {
      image: '5.png',
      title: 'Sony',
      id: '#CFDE-2163',
      qty: 'X1',
      status: 'Rejected',
      statusCode: 'danger',
      price: 56,
      total: 390,
      iconName: '24-hour',
    },
    {
      image: '6.png',
      title: 'Samsung',
      id: '#CFDE-2780',
      qty: 'X2',
      status: 'Verified',
      statusCode: 'success',
      price: 100,
      total: 870,
      iconName: '24-hour',
    },
  ],
  [
    {
      image: '1.png',
      title: 'Sony',
      id: '#CFDE-2163',
      qty: 'X1',
      status: 'Verified',
      statusCode: 'success',
      price: 56,
      total: 100,
      iconName: '24-hour',
    },
    {
      image: '2.png',
      title: 'Sennheiser',
      id: '#CFDE-2780',
      qty: 'X2',
      status: 'Rejected',
      statusCode: 'danger',
      price: 156,
      total: 100,
      iconName: '24-hour',
    },
  ],
  [
    {
      image: '7.png',
      title: 'Chair',
      id: '#CFDE-2163',
      qty: 'X1',
      status: 'Verified',
      statusCode: 'success',
      price: 48,
      total: 50,
      iconName: '24-hour',
    },
    {
      image: '8.png',
      title: 'Office Chair',
      id: '#CFDE-2780',
      qty: 'X2',
      status: 'Rejected',
      statusCode: 'danger',
      price: 73,
      total: 75,
      iconName: '24-hour',
    },
  ],
  [
    {
      image: '9.png',
      title: 'Lamp',
      id: '#CFDE-2163',
      qty: 'X1',
      status: 'Verified',
      statusCode: 'success',
      price: 20,
      total: 25,
      iconName: '24-hour',
    },
    {
      image: '10.png',
      title: 'Bedside lamp',
      id: '#CFDE-2780',
      qty: 'X2',
      status: 'Rejected',
      statusCode: 'danger',
      price: 70,
      total: 88,
      iconName: '24-hour',
    },
  ],
];

export const TopCategoriesData = [
  {
    image: '1.png',
    title: 'Food & Drinks',
    subTitle: '12,200',
  },
  {
    image: '2.png',
    title: 'Furniture',
    subTitle: '7,510',
  },
  {
    image: '3.png',
    title: 'Grocery',
    subTitle: '15,475',
  },
  {
    image: '4.png',
    title: 'Electronics',
    subTitle: '27,840',
  },
  {
    image: '5.png',
    title: 'Toys & Games',
    subTitle: '8,788',
  },
  {
    image: '6.png',
    title: 'Desktop',
    subTitle: '10,673',
  },
  {
    image: '7.png',
    title: 'Mobile & Accessories',
    subTitle: '5,129',
  },
];

export const RecentActivityData = [
  {
    title: ' Added Bew Items',
    date: '8th March, 2022',
    subTitle: 'Quisque a consequat ante sit amet magna...',
    image: ['1', '2', '3'],
    status: 'primary',
  },
  {
    title: 'Anamika Comments this Poducts',
    date: '2nd Sep, Today',
    subTitle: 'Quisque a consequat ante sit amet magna...',
    status: 'warning',
  },
  {
    title: 'Jacksion Purchase ',
    date: '3nd Sep, 2022',
    subTitle: 'Quisque a consequat ante sit amet magna...',
    status: 'secondary',
  },
  {
    title: 'Anamika Comments this Poducts',
    date: '2nd Sep, Today',
    subTitle: 'Quisque a consequat ante sit amet magna...',
    status: 'success',
  },
];

export const ActiveLessonsList = [
  {
    image: '1.png',
    title: 'UI/UX',
    subTitle: 'Web design',
    chart: { color: ['var(--theme-deafult)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)'], series: [20, 5, 5, 5, 5, 5, 5] },
  },
  {
    image: '2.png',
    title: 'Vue 3',
    subTitle: 'JS Framework',
    chart: { color: ['var(--theme-deafult)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)'], series: [50, 10, 10, 10] },
  },
  {
    image: '3.png',
    title: 'Bootstrap 5',
    subTitle: 'Framework',
    chart: { color: ['var(--theme-deafult)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)', 'var(--chart-progress-light)'], series: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1] },
  },
];
export const LessonChartOption = {
  series: [],
  options: {
    chart: {
      type: 'donut',
      height: 80,
    },
    colors: ['#7366FF', '#E5E5E5'],
    legend: {
      show: false,
    },
    stroke: {
      width: 1,
      colors: 'var(--white)',
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            value: {
              fontSize: '11px',
              fontFamily: 'Rubik, sans-serif',
              fontWeight: 400,
              color: 'var(--chart-text-color)',
              offsetY: -12,
              formatter: function (val) {
                return val;
              },
            },
            total: {
              show: true,
              showAlways: false,
              label: 'Total',
              fontSize: '11px',
              fontFamily: 'Rubik, sans-serif',
            },
          },
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
        },
      },
      hover: {
        filter: {
          type: 'none',
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
        },
      },
    },
  },
};
export const OptionsVisitorChart = {
  series: [
    {
      name: 'Active',
      data: [18, 10, 65, 18, 28, 10],
    },
    {
      name: 'Bounce',
      data: [25, 50, 30, 30, 25, 45],
    },
  ],
  options: {
    chart: {
      type: 'bar',
      height: 270,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 6,
      colors: ['transparent'],
    },
    grid: {
      show: true,
      borderColor: 'var(--chart-border)',
      xaxis: {
        lines: {
          show: true,
        },
      },
    },
    colors: ['#FFA941', 'var(--theme-deafult)'],
    xaxis: {
      categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      tickAmount: 4,
      tickPlacement: 'between',
      labels: {
        style: {
          fontFamily: 'Rubik, sans-serif',
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      tickPlacement: 'between',
      labels: {
        style: {
          fontFamily: 'Rubik, sans-serif',
        },
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      fontFamily: 'Rubik, sans-serif',
      fontSize: '14px',
      fontWeight: 500,
      labels: {
        colors: 'var(--chart-text-color)',
      },
      markers: {
        width: 6,
        height: 6,
        radius: 12,
      },
      itemMargin: {
        horizontal: 10,
      },
    },
    responsive: [
      {
        breakpoint: 1366,
        options: {
          plotOptions: {
            bar: {
              columnWidth: '80%',
            },
          },
          grid: {
            padding: {
              right: 0,
            },
          },
        },
      },
      {
        breakpoint: 992,
        options: {
          plotOptions: {
            bar: {
              columnWidth: '70%',
            },
          },
        },
      },
      {
        breakpoint: 576,
        options: {
          plotOptions: {
            bar: {
              columnWidth: '60%',
            },
          },
          grid: {
            padding: {
              right: 5,
            },
          },
        },
      },
    ],
  },
};
